import * as React from 'react';
import "./dashboard.css";
import {withUserCommunitiesContext} from "../community/context/userCommunitiesContext";
import NewsFeed from "../newsFeed/NewsFeed";
import {withNavigation} from "../navigation/navigation";
import {useEffect} from "react";
import {useAuthentication} from "../auth/hooks/useAuthentication";
import {useSynchronisation} from "../event/hooks/useSynchronisation";

function Dashboard({setToken, setShowNav}) {
    const {isLoading} = useAuthentication();
    const {checkIfCalendarNextCloudIsCreated} = useSynchronisation();

    useEffect(() => {
        setShowNav(false);
    }, []);

    useEffect(() => {
        if (!isLoading) {
            console.log('ato');
            checkIfCalendarNextCloudIsCreated();
        }
    }, [isLoading]);

    return (
        !isLoading && <NewsFeed setShowNav={setShowNav}></NewsFeed>
    );
}

export default withNavigation(withUserCommunitiesContext(Dashboard));
